import * as store from '@/store';

function getDisplayName<T>(WrappedComponent: React.FC<T>) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

interface IWithAfterDomReady {
    docReady?: boolean;
}

export function withAfterDomReady<T>(WrappedComponent: React.FC<T>) {

    const WithAfterDomReady = (props: T & IWithAfterDomReady) => {
        return props.docReady ? <WrappedComponent {...props} /> : null;
    };

    WrappedComponent.displayName = `${getDisplayName<T>(WrappedComponent)}`;

    return store.connect([
        store.KEYS.DOC_READY,
    ])(WithAfterDomReady);
}
